import { Draft, PayloadAction } from '@reduxjs/toolkit';
import IWorker from 'models/Worker';

import { IWorkerData } from '../../initialState';

interface ICreateWorkerSuccessAction {
  worker: IWorker;
}

function createSuccess(
  draft: Draft<IWorkerData>,
  action: PayloadAction<ICreateWorkerSuccessAction>,
) {
  draft.create.config.isLoading = false;
  draft.getAll.list = draft.getAll.list.concat(action.payload.worker);
}

export default createSuccess;
